import EqModList from "./components/List"
import EqModForm from "./components/Form"

let module = "equipment-models"

export default [
  { path: "equipment-models", component: EqModList, meta: { module: module, permissions: ["equipment-access"] } },
  {
    path: "equipment-models/create",
    component: EqModForm,
    props: true,
    meta: { module: module, permissions: ["equipment-access"] }
  },
  {
    path: "equipment-models/edit/:id",
    component: EqModForm,
    props: true,
    meta: { module: module, permissions: ["equipment-access"] }
  },
]
